/* SearchResultPageLegacy.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _10 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _9 = "._p12f1osq{max-width:100%}";
const _8 = "._1bsb1k7l{width:757px}";
const _7 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _6 = "._1yt4fkly{padding:0 var(--ds-space-400,2pc)}";
const _5 = "._1yt48v25{padding:0 0 var(--ds-space-800,4pc) 0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BackToTopButton, Filters, FluidContainer, Meta, PartialOutageError, WebPageStructuredData } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import { CompatibleProductName } from '@atlassian/mpac-types';
import { useLocation, useQueryParams } from '@atlassian/mpac-ui';
import { isOptionSelected, useApplicationConfig, useSource } from '@atlassian/mpac-utils';
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { ANALYTICS } from '../constants';
import { SearchEmbedded } from '../SearchEmbedded';
import { SearchBreadcrumbs, SearchHeading } from './components';
import { SearchResults } from './components/SearchResults';
import { useSearchFilters } from './hooks/useSearchFilters';
import { useSearchPageAnalytics } from './hooks/useSearchPageAnalytics';
import { useSearchPageTelemetry } from './hooks/useSearchPageTelemetry';
import { useSearchResults } from './hooks/useSearchResults';
import { getFilterPropertyValues } from './utils/filters/getFilterPropertyValues';
import { getOverridesByHostProduct } from './utils/filters/GetOverridesByHostProduct';
import { resolveMetaDescription } from './utils/metadata/metaUtils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "._1tke1kw7{min-height:inherit}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1yt4j3ea{padding:var(--ds-space-400,2pc) 0 var(--ds-space-800,4pc) 0}";
const SearchPageContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FluidContainer,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4j3ea _1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchPageContainer.displayName = 'SearchPageContainer';
}
const SearchPageContainerStyle = null;
const SearchPageEMCEEContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = SearchPageContainer,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt48v25", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchPageEMCEEContainer.displayName = 'SearchPageEMCEEContainer';
}
export const OutageErrorContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4fkly _1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OutageErrorContainer.displayName = 'OutageErrorContainer';
}
const EmbeddedFilterWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EmbeddedFilterWrapper.displayName = 'EmbeddedFilterWrapper';
}
const EmbeddedFilterWrapperStyle = null;
const SearchEmbeddedWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1k7l _p12f1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedWrapper.displayName = 'SearchEmbeddedWrapper';
}
export const getSearchQuery = query => {
  if (!query) return '';
  return Array.isArray(query) ? query[0] : query;
};

// eslint-disable-next-line max-lines-per-function
const SearchResultPage = props => {
  var _selectedOptions$host, _selectedOptions$host2, _commitOptions$produc, _commitOptions$produc2;
  const {
    enableFlexibleBillingFilter
  } = useStatsig();
  const [showPageError, setShowPageError] = useState(false);
  const {
    query,
    categories,
    useCases
  } = useQueryParams();
  const {
    pathname,
    search
  } = useLocation();
  const searchQuery = getSearchQuery(query);
  const searchInputRef = useRef(null);
  const {
    handleErrorStateAnalytics
  } = useSearchPageAnalytics();
  const source = useSource();
  const appConfig = useApplicationConfig();
  const {
    filterDefinitions,
    additionalFilters
  } = useMemo(() => getOverridesByHostProduct({
    hostProductId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId,
    enableFlexibleBillingFilter: enableFlexibleBillingFilter()
  }), [appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId, enableFlexibleBillingFilter]);
  const {
    // states
    allFilterDefinitions,
    filterOptions,
    selectedOptions,
    filterStatus,
    sortOptions,
    commitSortKey,
    commitOptions,
    selectedMobileSortOption,
    // booleans
    showAllFilters,
    isFiltersFetchPending,
    // set states
    setShowAllFilters,
    // functionality
    onClearFilter,
    onClearAllFilters,
    onSelectedOptionsChange,
    onApplyFilters,
    onSelectedSortOptionChange,
    onCloseMobileDialog,
    onCommitSortOptionSelect,
    handleClearFilters
  } = useSearchFilters(filterDefinitions, source);
  const {
    gridProps,
    analyticsFilters
  } = useSearchResults(searchQuery, commitOptions, isFiltersFetchPending, commitSortKey, showPageError, additionalFilters, filterDefinitions);
  const isSearchQueryActive = !!searchQuery;
  const areFiltersActive = isOptionSelected(selectedOptions);
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isMpacWebCoherenceEnabled = enableMpacWebCoherence();
  useSearchPageTelemetry({
    gridProps,
    searchQuery,
    commitOptions,
    commitSortKey
  });
  const appliedFilters = useMemo(() => getFilterPropertyValues(commitOptions, allFilterDefinitions), [commitOptions, allFilterDefinitions]);
  useEffect(() => {
    if ((filterStatus.categories === 'error' || filterStatus.useCases === 'error') && (categories || useCases)) {
      setShowPageError(true);
    }
  }, [categories, filterStatus, useCases]);
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  useEffect(() => {
    // HANDLE ANALYTICS
    if (showPageError) {
      handleErrorStateAnalytics({
        actionSubjectId: 'SearchPageErrorRendered',
        errorType: ANALYTICS.GLOBAL
      });
    }
  }, [showPageError]);
  if (showPageError) {
    return /*#__PURE__*/_jsx(OutageErrorContainer, {
      children: /*#__PURE__*/_jsx(PartialOutageError, {
        level: "global"
      })
    });
  }
  const ContainerComponent = source === 'MPAC' ? SearchPageContainer : SearchPageEMCEEContainer;
  const productName = appConfig !== null && appConfig !== void 0 && appConfig.hostProductId ? CompatibleProductName[appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId] : undefined;
  const selectedHostingFilter = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$host = selectedOptions.hosting) === null || _selectedOptions$host === void 0 ? void 0 : (_selectedOptions$host2 = _selectedOptions$host[0]) === null || _selectedOptions$host2 === void 0 ? void 0 : _selectedOptions$host2.value;
  const metaTitle = 'Search Results';
  const metaDescription = resolveMetaDescription(commitOptions === null || commitOptions === void 0 ? void 0 : (_commitOptions$produc = commitOptions.product) === null || _commitOptions$produc === void 0 ? void 0 : (_commitOptions$produc2 = _commitOptions$produc[0]) === null || _commitOptions$produc2 === void 0 ? void 0 : _commitOptions$produc2.label, commitSortKey);
  const canonicalUrl = "".concat((appConfig === null || appConfig === void 0 ? void 0 : appConfig.mpacBaseUrl) || 'https://marketplace.atlassian.com').concat(pathname).concat(search);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10]
    }), /*#__PURE__*/_jsxs(ContainerComponent, {
      "data-testid": "".concat(source, "-fluid-container"),
      className: ax([source === 'MPAC' && isMpacWebCoherenceEnabled && "_zulppxbi"]),
      children: [source === 'MPAC' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Meta, {
          title: metaTitle,
          description: metaDescription,
          canonicalUrl: canonicalUrl
        }), /*#__PURE__*/_jsx(WebPageStructuredData, {
          title: metaTitle,
          description: metaDescription,
          canonicalUrl: canonicalUrl,
          additionalProperty: appliedFilters.length > 0 ? appliedFilters : undefined
        }), /*#__PURE__*/_jsx(SearchBreadcrumbs, {})]
      }), /*#__PURE__*/_jsx(SearchHeading, {
        isSearchQueryActive: isSearchQueryActive,
        areFiltersActive: areFiltersActive,
        productName: productName
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_11]
        }), /*#__PURE__*/_jsxs(EmbeddedFilterWrapper, {
          className: ax([isMpacWebCoherenceEnabled && "_zulputpp"]),
          children: [/*#__PURE__*/_jsx(SearchEmbeddedWrapper, {
            children: /*#__PURE__*/_jsx(SearchEmbedded, {
              searchInputRef: searchInputRef
            })
          }), /*#__PURE__*/_jsx(Filters, {
            filterOptions: filterOptions,
            filterDefinitions: allFilterDefinitions,
            filterStatus: filterStatus,
            showAllFilters: showAllFilters,
            onShowAllFilters: () => setShowAllFilters(!showAllFilters),
            selectedOptions: selectedOptions,
            onSelectedOptionsChange: onSelectedOptionsChange,
            sortOptions: sortOptions,
            selectedSortOption: selectedMobileSortOption,
            onSelectedSortOptionChange: onSelectedSortOptionChange,
            onClearFilter: onClearFilter,
            onClearAllFilters: onClearAllFilters,
            onApplyFilters: onApplyFilters,
            onCloseMobileDialog: onCloseMobileDialog
          })]
        })]
      }), /*#__PURE__*/_jsx(SearchResults, {
        searchInputRef: searchInputRef,
        gridProps: gridProps,
        isSearchQueryActive: isSearchQueryActive,
        onSortOptionSelect: onCommitSortOptionSelect,
        areFiltersActive: areFiltersActive,
        handleClearAllFilters: handleClearFilters,
        selectedSortKey: commitSortKey,
        analyticsFilters: analyticsFilters,
        isAppInstalled: props.isAppInstalled,
        selectedHostingFilter: selectedHostingFilter
      }), /*#__PURE__*/_jsx(BackToTopButton, {})]
    })]
  });
};
export default SearchResultPage;